module.exports = __webpack_public_path__ + "media/images/simulation/ic_calender-4d263fd6d7957bbfa16a0d132aa2e0e2.svg";